import { Controller } from 'stimulus'
import './component.scss'

class CompanyShowNavigationController extends Controller {
  scrollToStaff(event) {
    const target = document.getElementById('company-show-staff-pc')
    if (target) {
      event.preventDefault()
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

window.Stimulus.register('company-show-navigation', CompanyShowNavigationController)
